import * as admin from "firebase-admin";

export interface SongModel {
    songID: string
    creatorID: string
    title: string
    artistName: string
    artistHandle: string
    creationTime: admin.firestore.Timestamp
    duration: number
    songType?: number
    isPublic?: boolean
    gifURL?: string
    numListens: number
}

export enum SongPrivacyType {
    forPublic = 0,
    forFriend = 1,
    forPrivate = 2,
}
